/* Susanne Ertsland Askvik — editorial sections
   Scroll reveals + external links in a new tab.
   Scoped to .se so nothing else on the page is touched. */
(function () {
  /* mark the document so CSS only hides things when JS can show them again */
  document.documentElement.classList.add('se-js');

  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targets = document.querySelectorAll('.se .reveal, .se .veil');

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      targets.forEach(function (el) { io.observe(el); });
    }

    var host = location.hostname;
    document.querySelectorAll('.se a[href]').forEach(function (a) {
      var h = a.getAttribute('href') || '';
      if (!/^https?:\/\//i.test(h)) return;
      if (a.hostname && a.hostname === host) return;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* re-run when a section is edited in the theme editor */
  document.addEventListener('shopify:section:load', init);
})();
